import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';
import { objectList } from './constants';

const model = {
  state: {
    queryParams: {
      per_page: 50,
      cur_page: 1,
    },
    listLoading: false,
    list: [],
    listTotal: 0,
    submitLoading: false,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { OperationNotice }, getState }) => ({
    // 获取列表
    async getList() {
      const { queryParams } = getState().OperationNotice;
      const { channel, time, cityName, businessDistrictName, companyName, cur_page, per_page } =
        queryParams;
      let beginTime;
      let endTime;
      if (time && time.length === 2) {
        beginTime = time[0].format('YYYY-MM-DD HH:mm:ss');
        endTime = time[1].format('YYYY-MM-DD HH:mm:ss');
      }
      OperationNotice.setState({ listLoading: true });
      const data = await fetch('/saasmerchant/web/announcement/announcementList', {
        type: 'GET',
        params: filterNull({
          channel,
          beginTime,
          endTime,
          cityName,
          businessDistrictName,
          companyName,
          page: cur_page,
          pageSize: per_page,
        }),
      });
      OperationNotice.setState({ listLoading: false });
      if (data) {
        OperationNotice.setState({
          list: data.list,
          listTotal: data.total,
        });
      }
    },
    // 搜索
    onSearch(queryParams) {
      OperationNotice.setState({ queryParams });
      OperationNotice.getList();
    },
    // 重置筛选项
    onReset() {
      OperationNotice.setState({
        queryParams: {
          per_page: 50,
          cur_page: 1,
        },
      });
    },
    // 翻页
    onNav(page) {
      const { queryParams } = getState().OperationNotice;
      OperationNotice.setState({ queryParams: { ...queryParams, cur_page: page } });
      OperationNotice.getList();
    },
    // 新建公告
    async createNotice(params, history) {
      OperationNotice.setState({ submitLoading: true });
      const data = await fetch('/saasmerchant/web/announcement/newAnnouncement', {
        params,
        type: 'POST',
        useJson: true,
      });
      OperationNotice.setState({ submitLoading: false });
      if (data) {
        message.success('新建公告成功');
        history.push('/user/notice');
      }
    },
    // 编辑公告
    async editNotice(params, history) {
      OperationNotice.setState({ submitLoading: true });
      const data = await fetch('/saasmerchant/web/announcement/updateAnnouncement', {
        params,
        type: 'POST',
        useJson: true,
      });
      OperationNotice.setState({ submitLoading: false });
      if (data) {
        message.success('编辑公告成功');
        history.push('/user/notice');
      }
    },
    // 删除公告
    async deleteNotice(announcementId) {
      const data = await fetch('/saasmerchant/web/announcement/delAnnouncement', {
        params: {
          announcementId,
          isDeleted: 1,
        },
        type: 'GET',
      });
      if (data) {
        message.success('删除公告成功');
        OperationNotice.getList();
      }
    },
    // 公告详情
    async getNoticeDetail(announcementId) {
      const data = await fetch('/saasmerchant/web/announcement/announcementDetail', {
        params: { announcementId },
        type: 'GET',
      });
      if (data) {
        const { targetType, targetDescIds } = data;
        // 初始化投放对象信息
        if (targetType) {
          data[objectList.find((object) => object.value === targetType).key] = targetDescIds;
        }
      }
      return data;
    },
  }),
};

export default model;
